import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import {
  Box,
  Drawer,
  FormControl,
  FormControlLabel,
  FormGroup,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Switch,
  Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import Grid2 from '@mui/material/Grid2';
import notification1 from 'assets/sounds/bottle.mp3';
import notification2 from 'assets/sounds/ding-126626.mp3';
import notification3 from 'assets/sounds/level-up-191997.mp3';
import notification4 from 'assets/sounds/livechat-129007.mp3';
import notification5 from 'assets/sounds/notification-1-269296.mp3';
import notification6 from 'assets/sounds/notification-2-269292.mp3';
import notification7 from 'assets/sounds/notification-pluck-off-269290.mp3';
import notification8 from 'assets/sounds/pop-on-269286.mp3';
import notification9 from 'assets/sounds/ui-sound-off-270300.mp3';
import logo from 'assets/images/logoProdutos/alertai_icon_light.svg';

interface DeviceEditionComponentProps {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

type SoundKey = 10 | 20 | 30 | 40 | 50 | 60 | 70 | 80 | 90;

const MonitoringOptionsNotificationComponent = ({
  isOpen,
  setIsOpen,
}: DeviceEditionComponentProps) => {
  const [state, setState] = useState({
    ivs: true,
    lpr: false,
    gatway: true,
    alarme: false,
    defense: false,
    faciais: false,
  });

  const [selectedSound, setSelectedSound] = useState<SoundKey | ''>('');
  const [selectedOption, setSelectedOption] = useState<string>('');

  const soundMap: Record<SoundKey, string> = {
    10: notification1,
    20: notification2,
    30: notification3,
    40: notification4,
    50: notification5,
    60: notification6,
    70: notification7,
    80: notification8,
    90: notification9,
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setState({
      ...state,
      [event.target.name]: event.target.checked,
    });
  };

  const handleChangeSound = (event: SelectChangeEvent<SoundKey | ''>) => {
    const sound = event.target.value as SoundKey;
    setSelectedSound(sound);

    if (soundMap[sound]) {
      const audio = new Audio(soundMap[sound]);
      audio.play();
    }
  };

  const handleRadioChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedOption(event.target.value);
  };

  const saveToCache = () => {
    localStorage.setItem(
      'monitoringOptions',
      JSON.stringify({ ...state, selectedOption, selectedSound }),
    );
    setIsOpen(false);
  };

  const loadFromCache = () => {
    const cachedState = localStorage.getItem('monitoringOptions');
    if (cachedState) {
      const parsedState = JSON.parse(cachedState);
      setState(parsedState);
      setSelectedOption(parsedState.selectedOption || '');
      setSelectedSound(parsedState.selectedSound || '');
    }
  };

  useEffect(() => {
    loadFromCache();
  }, []);

  return (
    <Drawer open={isOpen} onClose={() => setIsOpen(false)} anchor="right">
      <Grid2
        container
        display={'flex'}
        justifyContent={'center'}
        sx={{ mt: 2, width: 400 }}
        rowSpacing={1}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
      >
        <Box display={'flex'} justifyItems={'center'} marginY={2}>
          <img key="logo-expanded" height={38} src={logo} />
        </Box>
        <Grid2>
          <hr></hr>
          <Typography sx={{ marginTop: 5 }}>Ativar notificação:</Typography>
          <FormGroup>
            <Box display={'flex'} sx={{ marginY: 3 }}>
              <Grid2 display={'flex'} flexDirection={'column'}>
                <FormControlLabel
                  label="Lpr"
                  control={
                    <Switch
                      checked={state.lpr}
                      onChange={handleChange}
                      name="lpr"
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.ivs}
                      onChange={handleChange}
                      name="ivs"
                    />
                  }
                  label="Ivs"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.gatway}
                      onChange={handleChange}
                      name="gatway"
                    />
                  }
                  label="Gateway"
                />
              </Grid2>
              <Grid2 display={'flex'} flexDirection={'column'}>
                <FormControlLabel
                  label="Alarme"
                  control={
                    <Switch
                      checked={state.alarme}
                      onChange={handleChange}
                      name="alarme"
                    />
                  }
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.defense}
                      onChange={handleChange}
                      name="defense"
                    />
                  }
                  label="Defense"
                />
                <FormControlLabel
                  control={
                    <Switch
                      checked={state.faciais}
                      onChange={handleChange}
                      name="faciais"
                    />
                  }
                  label="Eventos Faciais"
                />
              </Grid2>
            </Box>
          </FormGroup>
          <Typography sx={{ marginTop: 2 }}>Tipo de notificação:</Typography>
          <FormControl sx={{ marginY: 2, width: '80%' }}>
            <InputLabel id="notification-select-label">Notificação</InputLabel>
            <Select
              labelId="notification-select-label"
              id="notification-select"
              value={selectedSound}
              label="Notificação"
              onChange={handleChangeSound}
            >
              {Object.keys(soundMap).map((key) => (
                <MenuItem key={key} value={key}>
                  {`Sound ${key}`}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <LoadingButton
            type="submit"
            onClick={saveToCache}
            variant="contained"
            color="primary"
            sx={{ marginY: 2, width: '100%' }}
          >
            Salvar
          </LoadingButton>
        </Grid2>
      </Grid2>
    </Drawer>
  );
};

export default MonitoringOptionsNotificationComponent;
